<template>
	<view class="flex-col page">
		<!-- #ifdef APP-PLUS -->
		<view class="status_bar">
			<view class="top_view"></view>
		</view>
		<!-- #endif -->
		<u-icon name="arrow-left" class="back" color="#707070" size="40" @click="pageBack">
		</u-icon>
		<view class="flex-col group">
			<text class="text">忘记密码</text>
			<text class="text_1">请输入手机号验证码修改密码</text>
			<view class="flex-col group_1">
				<view class="flex-row section_1">
					<u-icon name="account" color="#707070" size="30" style="margin-right: 12rpx;"></u-icon>
					<input style="font-size: 28rpx;" type="text" v-model="form1.mobile" :maxlength="11"
						placeholder="请输入您的手机号" placeholder-class="input-placeholder" />
				</view>
				<view class="justify-between section_2">
					<view class="flex-row group_2">
						<u-icon name="email" color="#707070" size="30" style="margin-right: 12rpx;"></u-icon>
						<input style="font-size: 28rpx;" type="number" password v-model="form1.code" placeholder="验证码"
							placeholder-class="input-placeholder" />
					</view>
					<view class="flex-col text-wrapper">
						<!-- 验证码倒计时开始 -->
						<vk-u-verification-code seconds="60" :mobile="form1.mobile" type="reset">
						</vk-u-verification-code>
						<!-- 验证码倒计时结束 -->
					</view>
				</view>
				<view class="section_3 flex-row">
					<u-icon name="lock" color="#707070" size="30" style="margin-right: 12rpx;"></u-icon>
					<input style="font-size: 28rpx;" type="text" password v-model="form1.password" placeholder="请输入新密码"
						placeholder-class="input-placeholder" />
				</view>
				<view class="section_3 flex-row">
					<u-icon name="lock" color="#707070" size="30" style="margin-right: 12rpx;"></u-icon>
					<input style="font-size: 28rpx;" type="text" password v-model="form1.password2"
						placeholder="请再次输入新密码" placeholder-class="input-placeholder" />
				</view>
			</view>
			<view class="flex-col items-center button" @click="resetPassword">
				<text>确定</text>
			</view>
		</view>
	</view>
</template>

<script>
	var that; // 当前页面对象
	var vk; // vk依赖
	export default {
		data() {
			// 页面数据变量
			return {
				// init请求返回的数据
				data: {

				},
				// 表单请求数据
				form1: {
					mobile: "",
					password: "",
					password2: "",
					code: ""
				},
				scrollTop: 0,
				isRotate: false
			}
		},
		onPageScroll(e) {
			that.scrollTop = e.scrollTop;
		},
		// 监听 - 页面每次【加载时】执行(如：前进)
		onLoad(options) {
			that = this;
			vk = that.vk;
			//console.log("onLoad",options);
			that.init(options);
		},
		// 监听 - 页面【首次渲染完成时】执行。注意如果渲染速度快，会在页面进入动画完成前触发
		onReady() {

		},
		// 监听 - 页面每次【显示时】执行(如：前进和返回) (页面每次出现在屏幕上都触发，包括从下级页面点返回露出当前页面)
		onShow() {

		},
		// 监听 - 页面每次【隐藏时】执行(如：返回)
		onHide() {


		},
		// 监听 - 页面下拉刷新
		onPullDownRefresh() {
			setTimeout(function() {
				uni.stopPullDownRefresh();
			}, 1000);
		},
		// 监听 - 页面触底部
		onReachBottom() {

		},
		// 监听 - 窗口尺寸变化(仅限:App、微信小程序)
		onResize() {

		},
		// 监听 - 点击右上角转发时
		onShareAppMessage(options) {

		},
		// 监听 - 页面创建时
		created() {

		},
		// 函数
		methods: {
			// 页面数据初始化函数
			init(options = {}) {
				console.log("init: ", options);
			},
			pageBack() {
				uni.navigateBack({
					delta: 1
				})
			},
			pageTo(path) {
				vk.navigateTo(path);
			},
			resetPassword() {
				const { mobile, code, password, password2 } = that.form1;
				//重置密码
				if (that.isRotate) {
					//判断是否加载中，避免重复点击请求
					return false;
				}
				if (!vk.pubfn.checkStr(mobile, 'mobile')) {
					vk.toast('请输入正确的手机号码', "none");
					return;
				}
				if (!vk.pubfn.checkStr(password, 'pwd')) {
					vk.toast('密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线', "none");
					return;
				}
				if (!vk.pubfn.checkStr(password2, 'pwd')) {
					vk.toast('密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线', "none");
					return;
				}
				if (password != password2) {
					vk.toast('两次密码必须相同!', "none");
					return;
				}
				if (!vk.pubfn.checkStr(code, 'mobileCode')) {
					vk.toast('验证码格式为6位数字', "none");
					return;
				}
				that.isRotate = true;
				vk.userCenter.resetPasswordByMobile({
					data: that.form1,
					success: function(data) {
						that.isRotate = false;
						vk.alert("密码重置成功,新密码为:" + password, function() {
							// 进入首页
							vk.redirectTo("../index/index");
						});
					},
					complete: function() {
						that.isRotate = false;
					}
				});
			}
		},
		// 过滤器
		filters: {

		},
		// 计算属性
		computed: {

		}
	}
</script>
<style lang="scss" scoped>
	.page {
		background-color: #f5f5f5;
		width: 100%;
		height: 100vh;
		overflow-y: auto;

		.back {
			padding: 30rpx 20rpx 0;
			height: 11.5vw;
		}

		.group {
			padding: 50rpx 30rpx 0;
			flex: 1 1 auto;
			overflow-y: auto;

			.text {
				color: rgb(51, 51, 51);
				font-size: 42rpx;
				line-height: 50rpx;
				letter-spacing: 2.1rpx;
				white-space: nowrap;
				font-weight: bold;
			}

			.text_1 {
				margin-top: 47rpx;
				color: rgb(153, 153, 153);
				font-size: 28rpx;
				line-height: 34rpx;
				white-space: nowrap;
			}

			.group_1 {
				margin-top: 141rpx;

				.section_1 {
					padding: 34rpx 60rpx 32rpx;
					color: rgb(153, 153, 153);
					font-size: 28rpx;
					line-height: 34rpx;
					white-space: nowrap;
					background-color: rgb(255, 255, 255);
					border-radius: 50rpx;
				}

				.section_2 {
					margin-top: 40rpx;
					padding-left: 62rpx;
					background-color: rgb(255, 255, 255);
					border-radius: 50rpx;

					.group_2 {
						align-self: center;
						color: rgb(153, 153, 153);
						font-size: 28rpx;
						line-height: 34rpx;
						white-space: nowrap;
					}

					.text-wrapper {
						padding: 34rpx 20rpx;
						color: rgb(255, 255, 255);
						font-size: 28rpx;
						line-height: 34rpx;
						white-space: nowrap;
						background-color: rgb(51, 51, 51);
						border-radius: 0px 50rpx 50rpx 0px;
						height: 100rpx;
					}
				}

				.section_3 {
					margin-top: 40rpx;
					color: rgb(153, 153, 153);
					font-size: 28rpx;
					line-height: 34rpx;
					white-space: nowrap;
					padding: 34rpx 64rpx 32rpx;
					background-color: rgb(255, 255, 255);
					border-radius: 50rpx;
				}
			}

			.button {
				margin-top: 118rpx;
				padding: 32rpx 0 30rpx;
				color: rgb(255, 255, 255);
				font-size: 32rpx;
				line-height: 38rpx;
				white-space: nowrap;
				background-color: rgb(51, 51, 51);
				border-radius: 50rpx;
			}
		}
	}
</style>
